const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls, MediaUploadCheck, MediaUpload } =
  wp.blockEditor;
const { PanelBody, RadioControl, Button, IconButton } = wp.components;
const { Fragment, useState, useEffect } = wp.element;
const { __ } = wp.i18n;

const baseClass = 'custom-icon';

// Updated IconUpload to include alt text
const IconUpload = ({ onChange, value }) => (
  <MediaUploadCheck>
    <MediaUpload
      onSelect={(media) => onChange({ url: media.url, alt: media.alt })}
      allowedTypes={['image']}
      render={({ open }) => (
        <>
          {value && value.url && (
            <img src={value.url} alt={value.alt} className={baseClass} />
          )}
          <Button onClick={open} isPrimary isSmall>
            {value && value.url ? (
              <>Change Icon</>
            ) : (
              <>
                <IconButton icon="upload" />
                Upload Icon
              </>
            )}
          </Button>
        </>
      )}
    />
  </MediaUploadCheck>
);

// Updated IconView to include alt text
const IconView = ({ icon }) =>
  icon && icon.url ? (
    <img src={icon.url} alt={icon.alt || 'Icon'} className={baseClass} />
  ) : null;

registerBlockType('pg/columns-section-inner', {
  title: __('PG Columns Section Inner'),
  icon: 'screenoptions',
  category: 'layout',
  parent: ['pg/columns-section'],
  attributes: {
    sectionTitle: {
      type: 'string',
      source: 'html',
      selector: 'h3',
      default: '',
    },
    columns: {
      type: 'array',
      default: [],
    },
    columnsNumber: {
      type: 'string',
      default: '4',
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const { sectionTitle, columns, columnsNumber } = attributes;
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
      setLoaded(true);
    }, []);

    const addColumn = () => {
      const newColumn = {
        icon: { url: '', alt: '' },
        title: '',
        description: '',
      };
      setAttributes({ columns: [...[newColumn], ...columns] });
    };

    const updateColumn = (index, updates) => {
      const newColumns = columns.map((column, i) =>
        i === index ? { ...column, ...updates } : column
      );
      setAttributes({ columns: newColumns });
    };

    const removeColumn = (index) => {
      const newColumns = columns.filter((_, i) => i !== index);
      setAttributes({ columns: newColumns });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Column Settings')}>
            <Button isSecondary onClick={addColumn}>
              + Add Column
            </Button>
            <RadioControl
              label={__('Columns Number')}
              selected={columnsNumber}
              options={[
                { label: '4 Columns', value: '4' },
                { label: '3 Columns', value: '3' },
                { label: '2 Columns', value: '2' },
              ]}
              onChange={(value) => setAttributes({ columnsNumber: value })}
            />
          </PanelBody>
        </InspectorControls>
        <div className="columns-section">
          <RichText
            tagName="h3"
            value={sectionTitle}
            onChange={(newTitle) => setAttributes({ sectionTitle: newTitle })}
            placeholder={__('Purpose-built for your sustainability journey')}
          />
          <div className={`columns-wrapper columns-${columnsNumber}`}>
            {columns.map((column, index) => (
              <div key={index} className={`column`}>
                {loaded && (
                  <IconUpload
                    onChange={(icon) => updateColumn(index, { icon })}
                    value={column.icon}
                  />
                )}
                <RichText
                  tagName="h4"
                  value={column.title}
                  placeholder={__('Column Title')}
                  onChange={(newTitle) =>
                    updateColumn(index, { title: newTitle })
                  }
                />
                <RichText
                  tagName={'div'}
                  placeholder={__('Column Description')}
                  value={column.description}
                  onChange={(newDescription) =>
                    updateColumn(index, { description: newDescription })
                  }
                />
                <Button
                  isSmall
                  isPrimary
                  className="removeStaticButton"
                  onClick={() => removeColumn(index)}
                >
                  {__('Remove Column')}
                </Button>
              </div>
            ))}
          </div>
        </div>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const { sectionTitle, columns, columnsNumber } = attributes;

    return (
      <div className="columns-section">
        <RichText.Content tagName="h3" value={sectionTitle} />
        <div className={`columns-wrapper columns-${columnsNumber}`}>
          {columns.map((column, index) => (
            <div key={index} className={`column`}>
              <IconView icon={column.icon} />
              <RichText.Content tagName="h4" value={column.title} />
              <div dangerouslySetInnerHTML={{ __html: column.description }} />
            </div>
          ))}
        </div>
      </div>
    );
  },
});
